import React, { useRef } from 'react';
import { FormGroup } from '../../../form';
import { InputText, InputColor, InputRange } from '../../../formikBindings';
import ImageGallery from '../../../imageGallery';
import { useFormikContext } from 'formik';
import { IThemeFormValues, IWelcomePagesTabProps } from './types';
import WelcomePageFactory from './WelcomePageFactory';

const WelcomePagesTab: React.FC<IWelcomePagesTabProps> = ({
  images,
  selectedIndex,
  onSelectedIndexChanged,
}) => {
  const {
    values: { welcomePages },
    setFieldValue,
    isValid,
  } = useFormikContext<IThemeFormValues>();

  const textElementRef = useRef<HTMLInputElement>(null);

  const updateCurrentWelcomePageImage = (imageUrl: string): void => {
    setFieldValue('welcomePages', [
      ...welcomePages.slice(0, selectedIndex),
      { ...welcomePages[selectedIndex], imageUrl },
      ...welcomePages.slice(selectedIndex + 1),
    ]);
  };

  const addWelcomePage = (imageUrl: string): void => {
    setFieldValue('welcomePages', [
      ...welcomePages,
      {
        ...WelcomePageFactory.Create(),
        imageUrl,
      },
    ]);

    onSelectedIndexChanged(welcomePages.length);

    if (textElementRef.current === null) return;

    textElementRef.current.focus();
  };

  const deleteSelectedWelcomePage = (): void => {
    onSelectedIndexChanged(Math.max(selectedIndex - 1, 0), true);

    setFieldValue('welcomePages', [
      ...welcomePages.slice(0, selectedIndex),
      ...welcomePages.slice(selectedIndex + 1),
    ]);
  };

  return (
    <div>
      <ImageGallery
        images={images}
        selectedIndex={selectedIndex}
        allowAdd={isValid}
        onSelect={onSelectedIndexChanged}
        onUpload={updateCurrentWelcomePageImage}
        onAdd={addWelcomePage}
        onDelete={deleteSelectedWelcomePage}
      />
      <p>
        <small>
          <strong>Tip: </strong>Avoid using text in the images you upload, they
          may not display correctly on different size devices.
        </small>
      </p>
      <FormGroup
        name={`welcomePages[${selectedIndex}].text`}
        label="Text"
        required
      >
        <InputText
          ref={textElementRef}
          name={`welcomePages[${selectedIndex}].text`}
          maxLength={255}
        />
      </FormGroup>

      <FormGroup
        name={`welcomePages[${selectedIndex}].textColor`}
        label="Text Colour"
      >
        <InputColor name={`welcomePages[${selectedIndex}].textColor`} />
      </FormGroup>

      <FormGroup
        name={`welcomePages[${selectedIndex}].opacityPercent`}
        label="Opacity"
        required
      >
        <InputRange
          name={`welcomePages[${selectedIndex}].opacityPercent`}
          min={0}
          max={100}
          step={5}
          showValue
          valueSuffix="%"
        />
      </FormGroup>
    </div>
  );
};

export default WelcomePagesTab;
